export default "__VITE_ASSET__DWsRqqsf__"